import Password2Fa from "./Password2Fa";

export default Password2Fa;
